//taken from https://usehooks.com/useOnClickOutside/
import { useEffect } from "react";

const useOnClickOutside = (refs, handler) => {
  if (!Array.isArray(refs)) refs = [refs];

  useEffect(
    () => {
      const listener = event => {
        // Do nothing if clicking refs' element or descendent elements
        if (refs.some(ref => 
          !ref.current || ref.current.contains(event.target)
        )) return;

        handler(event);
      };

      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);

      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [refs, handler]
  );
};

export default useOnClickOutside;
